<template>
  <div>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column prop="ip" label="登录ip"></el-table-column>
      <el-table-column prop="created_at" label="登录时间"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getApiData } from '../../http'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      dataList: undefined,
      dataMeta: {},
      loading: false,
      page: 1
    }
  },

  methods: {
    getTableData() {
      this.loading = true
      getApiData(`user_login_ip/${this.id}`, { page: this.page })
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.page = page
      this.getTableData()
    },
    handleTypeChange() {
      this.page = 1
      this.getTableData()
    }
  },
  created() {
    this.getTableData()
  }
}
</script>

<style lang="less" scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
